import * as React from 'react';
import styled from 'styled-components';
import Button from '../../../components/Button';
import { Application, ApplicationState } from '../types';

const Title = styled.div`
    float: left;
`;

const ButtonWrapper = styled.div`
    margin-top: 1.2rem;
    float: right;
    ${Button} + ${Button} {
        margin-left: 1rem;
    }
`;

const TextBox = styled.textarea`
    width: 99%;
    height: 8em;
    resize: none;
`;

const Modal = styled.div`
    display: block;
    position: fixed;
    z-index: 1;
    padding-top: 20rem;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
`;

const ModalContent = styled.div`
    background-color: #fefefe;
    margin: auto;
    padding: 2rem;
    border: 1px solid #888;
    max-width: 40rem;
    height: 20rem;
`;

class Decision extends React.Component<DecisionProps, DecisionState> {
    constructor(props: DecisionProps) {
        super(props);
        this.state = {
            showAcceptModal: false,
            showRejectModal: false,
            hiringManagerNotes: this.props.application.hiringManagerNotes
        };
    }

    protected showAcceptModal = () => {
        this.setState({
            showAcceptModal: true,
            hiringManagerNotes: this.props.application.hiringManagerNotes
        });
    };

    protected hideAcceptModal = () => {
        this.setState({
            showAcceptModal: false
        });
    };

    protected showRejectModal = () => {
        this.setState({
            showRejectModal: true,
            hiringManagerNotes: this.props.application.hiringManagerNotes
        });
    };

    protected hideRejectModal = () => {
        this.setState({
            showRejectModal: false
        });
    };

    public render() {
        return (
            <div>
                <Title>
                    <h1>
                        {this.props.application.firstName} {this.props.application.lastName}
                    </h1>
                </Title>
                {this.state.showAcceptModal && (
                    <Modal>
                        <ModalContent>
                            <h2>
                                Accept {this.props.application.firstName} {this.props.application.lastName}
                            </h2>
                            <TextBox
                                placeholder="Please leave a note so that we can follow your decision."
                                value={this.state.hiringManagerNotes}
                                onChange={e => this.setState({ hiringManagerNotes: e.target.value })}
                            />
                            <ButtonWrapper>
                                <Button normal onClick={() => this.hideAcceptModal()}>
                                    Cancel
                                </Button>
                                <Button
                                    onClick={() => {
                                        this.hideAcceptModal();
                                        this.props.onAccept({
                                            ...this.props.application,
                                            hiringManagerNotes: this.state.hiringManagerNotes
                                        });
                                    }}
                                >
                                    OK
                                </Button>
                            </ButtonWrapper>
                        </ModalContent>
                    </Modal>
                )}
                {this.state.showRejectModal && (
                    <Modal>
                        <ModalContent>
                            <h2>
                                Reject {this.props.application.firstName} {this.props.application.lastName}
                            </h2>
                            <TextBox
                                placeholder="Please leave a note so that we can follow your decision."
                                value={this.state.hiringManagerNotes}
                                onChange={e => this.setState({ hiringManagerNotes: e.target.value })}
                            />
                            <ButtonWrapper>
                                <Button normal onClick={() => this.hideRejectModal()}>
                                    Cancel
                                </Button>
                                <Button
                                    onClick={() => {
                                        this.hideRejectModal();
                                        this.props.onReject({
                                            ...this.props.application,
                                            hiringManagerNotes: this.state.hiringManagerNotes
                                        });
                                    }}
                                >
                                    OK
                                </Button>
                            </ButtonWrapper>
                        </ModalContent>
                    </Modal>
                )}
                {(this.props.application.applicationState === ApplicationState.APPLICATION_SUBMITTED ||
                    this.props.application.applicationState === ApplicationState.APPLICATION_ACCEPTED ||
                    this.props.application.applicationState === ApplicationState.APPLICATION_REJECTED) && (
                    <ButtonWrapper>
                        <Button
                            normal={this.props.application.applicationState !== ApplicationState.APPLICATION_ACCEPTED}
                            onClick={() => this.showAcceptModal()}
                        >
                            Accept
                        </Button>
                        <Button
                            normal={this.props.application.applicationState !== ApplicationState.APPLICATION_REJECTED}
                            onClick={() => this.showRejectModal()}
                        >
                            Reject
                        </Button>
                    </ButtonWrapper>
                )}
            </div>
        );
    }
}

interface DecisionProps {
    application: Application;
    onAccept: (application: Application) => void;
    onReject: (application: Application) => void;
}

interface DecisionState {
    showAcceptModal: boolean;
    showRejectModal: boolean;
    hiringManagerNotes: string;
}

export default Decision;



// WEBPACK FOOTER //
// ./src/scenes/hiring-manager/components/Decision.tsx